import { ProjectsPage } from "@/pages/ProjectsPage"
import { ScrollOnePager } from "@/pages/ScrollOnePager"
import { TagProjectsPage } from "@/pages/TagProjectsPage"
import { Switch, Route, Redirect } from "wouter"
import { Header } from "./Header"
import { LeftSidebar } from "./LeftSidebar"
import { RightSidebar } from "./RightSidebar"
import { TechStackSlot } from "@/components/sections/TechStackPanel"
import { FixedInfoPanel } from "@/components/sections/FixedInfoPanel"

export function Layout() {
  return (
    <>
      <Header />
      <LeftSidebar />
      <RightSidebar />
      <div data-panels-layer className="pointer-events-none fixed inset-0 z-40 flex justify-center">
        <div data-panels-inner className="flex h-full w-full max-w-7xl flex-col justify-between px-6 md:px-16 lg:px-24 2xl:px-0">
          <FixedInfoPanel />
          <div data-panels-tech-stack className="flex w-full self-end flex-col items-end pb-20 md:w-3/5 lg:pb-24">
            <TechStackSlot />
          </div>
        </div>
      </div>

      <main data-main className="pointer-events-none relative z-10 w-screen">
        <Switch>
          <Route path="/home" component={ScrollOnePager} />
          <Route path="/project/:id" component={ScrollOnePager} />
          <Route path="/project/:id/:image" component={ScrollOnePager} />
          <Route path="/contact" component={ScrollOnePager} />
          <Route path="/projects/:setSlug" component={ProjectsPage} />
          <Route path="/tags/:tag" component={TagProjectsPage} />
          <Route path="/projects">{() => <Redirect to="/home" />}</Route>
          <Route>{() => <Redirect to="/home" />}</Route>
        </Switch>
      </main>
    </>
  )
}
